import { DynamicQueryParams } from '@sonar-software/sonar-ts-types';

import { AccessObjectDetails, AccessType } from '@types';
import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';

export type GetDataSecurityAccessExplainerByObjectIdRequest = DynamicQueryParams & {
	accessId: string;
	objectId: string;
	type: AccessType;
};

export type GetDataSecurityAccessExplainerByObjectIdResponse = AccessObjectDetails;

export const getDataSecurityAccessExplainerByObjectId = createGetEndpoint<
	GetDataSecurityAccessExplainerByObjectIdRequest,
	GetDataSecurityAccessExplainerByObjectIdResponse
>(
	({ accessId, objectId, type, ...rest }) =>
		`/api/v3/salesforce/data-access/explain-access/${type}/${accessId}/object/${objectId}?${getQueryString(rest)}`
);
